<template>
  <!-- <div id="main"></div> -->
  <div ref="main" id="main">
    <!-- <div ref="toobar"
         id="editor-bar"
         class="editor-bar"></div>
    <div ref="editor"
         id="editor-content"
         class="editor-content"></div> -->
  </div>
</template>

<script>
import E from "wangeditor";
export default {
  data () {
    return {
      editor: "",
    };
  },
  mounted () {
    //创建wangeditor实例
    // this.editor = new E(this.$refs.toobar, this.$refs.editor);

    this.editor = new E(this.$refs.main);
    // 取消自动 focus
    this.editor.config.focus = false
    console.log("wangeditor", this.editor);
    // 配置 onchange 回调函数--获取输入的值内容
    this.editor.config.onchange = newHtml => {
      this.$emit('sendEditor', newHtml)
    };
    this.editor.config.showLinkImg = false
    // 配置触发 onchange 的时间频率，默认为 200ms
    this.editor.config.onchangeTimeout = 500; // 修改为 500ms
    this.editor.config.uploadImgShowBase64 = true;
    // 配置菜单栏，删减菜单，调整顺序
    // 默认情况下，显示所有菜单
    this.editor.config.menus = [
      "head",
      "bold",
      "fontSize",
      "fontName",
      "italic",
      "underline",
      "strikeThrough",
      "indent",
      "lineHeight",
      "foreColor",
      "backColor",
      "link",
      "list",
      "todo",
      "justify",
      // "quote",
      // "emoticon",
      "image",
      // "video",
      "table",
      // "code",
      "splitLine",
      "undo",
      "redo",
      "fullscreen",
    ];
    this.editor.create();
  }
};
</script>

<style scoped>

</style>